import { Swiper } from '@theme/mp-swiper';

class CarouselComponent extends HTMLElement {
  connectedCallback() {
    const slidesPerViewAttr = this.getAttribute('slide-per-view');
    const slidesPerView = slidesPerViewAttr === 'auto' ? 'auto' : parseFloat(slidesPerViewAttr) || 1;
    const spaceBetween = parseFloat(this.getAttribute('slide-gap'));
    const scrollbarEl = this.querySelector('.swiper-scrollbar');

    let breakpoints;
    const breakpointsAttr = this.getAttribute('slide-responsive-breakpoints');
    if (breakpointsAttr) {
      try {
        breakpoints = JSON.parse(breakpointsAttr);
      } catch (error) {
        console.error('carousel-component: invalid slide-responsive-breakpoints attribute', error);
      }
    }

    const slidesOffsetBefore = parseFloat(this.getAttribute('slide-offset-mobile'));
    if (slidesOffsetBefore && breakpoints) {
      for (const [width, breakpoint] of Object.entries(breakpoints)) {
        if (breakpoint.slidesOffsetBefore === undefined) {
          breakpoint.slidesOffsetBefore = Number(width) < 750 ? slidesOffsetBefore : 0;
        }
      }
    }

    const slidesOffsetTablet = parseFloat(this.getAttribute('slide-offset-tablet'));
    if (slidesOffsetTablet && breakpoints) {
      const sortedKeys = Object.keys(breakpoints).map(Number).sort((a, b) => a - b);
      const slidesPerViewAt = (width) => {
        let value = slidesPerView;
        for (const key of sortedKeys) {
          if (key <= width && breakpoints[key].slidesPerView !== undefined) {
            value = breakpoints[key].slidesPerView;
          }
        }
        return value;
      };

      breakpoints[750] = {
        ...breakpoints[750],
        slidesPerView: slidesPerViewAt(750),
        slidesOffsetBefore: slidesOffsetTablet,
      };
      breakpoints[990] = {
        ...breakpoints[990],
        slidesPerView: slidesPerViewAt(990),
        slidesOffsetBefore: 0,
      };
    }

    this.swiperConfig = {
      slidesPerView,
      ...(Number.isNaN(spaceBetween) ? {} : { spaceBetween }),
      ...(Number.isNaN(slidesOffsetBefore) ? {} : { slidesOffsetBefore }),
      ...(breakpoints ? { breakpoints } : {}),
      watchOverflow: true,
      ...(this.hasAttribute('free-mode') ? { freeMode: true } : {}),
      ...(scrollbarEl ? { scrollbar: { el: scrollbarEl, draggable: true } } : {}),
    };

    if (this.hasAttribute('no-mobile-slider')) {
      this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
      this.handleMediaChange = this.handleMediaChange.bind(this);
      this.mobileMediaQuery.addEventListener('change', this.handleMediaChange);

      if (this.mobileMediaQuery.matches) {
        return;
      }
    }

    this.initSwiper();
  }

  disconnectedCallback() {
    this.mobileMediaQuery?.removeEventListener('change', this.handleMediaChange);
    this.destroySwiper();
  }

  handleMediaChange(event) {
    if (event.matches) {
      this.destroySwiper();
    } else {
      this.initSwiper();
    }
  }

  initSwiper() {
    if (this.swiper) return;
    this.swiper = new Swiper(this, this.swiperConfig);
  }

  destroySwiper() {
    this.swiper?.destroy(true, true);
    this.swiper = undefined;
  }
}

if (!customElements.get('carousel-component')) {
  customElements.define('carousel-component', CarouselComponent);
}
